import styled from 'styled-components';

const PinCodeInputStyled = styled.div`
  position: relative;
`;

export default PinCodeInputStyled;
